<template>
  <a :href="link" ref="item" class="news-item" target="_blank" @mouseover="isHover = true" @mouseleave="isHover = false" :class="{ 'has-hover': hasHover }" :style="styleItem">
    <div class="news-item__hovered">
      <div class="news-item__container" :style="styleContainer">
        <div class="news-item__date">{{ item.date | parseFormatDate('d MMMM yyyy') }}</div>
        <figure class="news-item__picture">
          <img class="news-item__image" :src="image.standart" :srcset="`${image.double} 2x`" alt="">
        </figure>
        <h3 class="news-item__title">{{ item.title }}</h3>
        <div class="news-item__body">
          <div class="news-item__content">
            <p>{{ item.before_title }}</p>
          </div>
          <div class="news-item__readmore">
            Подробнее
          </div>
        </div>
    </div>
    </div>
  </a>
</template>

<script>
import { parseFormatDate } from '@/utils'

export default {
  props: {
    item: Object
  },
  data () {
    return {
      isHover: false,
      hasHover: false,
      height: null
    }
  },
  computed: {
    image () {
      return {
        standart: `https://kamgov.ru${this.item.image}`,
        double: `https://kamgov.ru${this.item.image2x}`
      }
    },
    link () {
      return `https://kamgov.ru/news/${this.item.alias}`
    },
    isDesktop () {
      return this.$mq.resize && this.$mq.above(this.$mv.lg)
    },
    styleItem () {
      if (!this.hasHover) return null

      return {
        height: `${this.height}px`
      }
    },
    styleContainer () {
      if (!this.hasHover) return null

      return {
        minHeight: `${this.height + 20}px`
      }
    }
  },
  watch: {
    isHover (val) {
      this.set(val)
    }
  },
  filters: {
    parseFormatDate
  },
  methods: {
    getHeight () {
      const { item } = this.$refs
      const rect = item.getBoundingClientRect()

      return rect.height
    },
    set (isHover) {
      if (isHover) {
        this.height = this.getHeight()
        setTimeout(() => {
          this.hasHover = true
        }, 10)
      } else {
        this.height = null
        this.hasHover = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.news-item {
  color: inherit;
  display: block;
  height: 100%;
  position: relative;

  &__hovered {
    .has-hover & {
      @include media-breakpoint-up(lg) {
        left: 0;
        top: 0;
        position: absolute;
        z-index: 5;
      }
    }
  }

  &__container {
    .has-hover & {
      @include media-breakpoint-up(lg) {
        background: $white;
        box-shadow: 0 0 14px 0 rgba($black, 0.12);
        margin: -20px -15px 0;
        padding: 20px 15px;
      }
    }
  }

  &:hover {
    text-decoration: none;
  }

  &__date {
    @include font-size($font-size-sm);
    color: $theme-gray-700;
    letter-spacing: 1px;
    margin-bottom: 5px;
    text-transform: uppercase;

    @include media-breakpoint-up(lg) {
      margin-bottom: 10px;
    }
  }

  &__picture {
    margin-bottom: 15px;

    .has-hover & {
      @include media-breakpoint-up(lg) {
        display: none;
      }
    }
  }

  &__image {
    @include img-fluid;
  }

  &__title {
    @include font-size($font-size-base);
    font-weight: normal;
    margin-bottom: 0;
    line-height: 1.3;

    @include media-breakpoint-up(lg) {
      @include font-size($font-size-lg);
    }
  }

  &__body {
    color: $theme-gray-700;
    display: none;
    margin-top: 20px;

    .has-hover & {
      @include media-breakpoint-up(lg) {
        display: block;
      }
    }
  }

  &__readmore {
    @include font-size($font-size-md);
    color: $theme-red-100;
    margin-top: 28px;
    text-transform: uppercase;
    position: relative;

    &:hover {
      text-decoration: underline;
    }

    &::before {
      background: $theme-red-100;
      content: '';
      display: block;
      height: 34px;
      left: -16px;
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      width: 3px;
    }
  }
}
</style>
